const CONFIGURATION = {
    defaultTheme: 'mipasa-light',
    authorizedDomains: ['mipasa.com'],
    apps: {
        mipasa: {
            enabled: true,
            url: 'https://staging.mipasa.com',
        },
        unbounded: {
            enabled: true,
            url: 'https://staging.unbounded.network',
        },
        papillon: {
            enabled: true,
            url: 'https://staging.papillon.unbounded.network',
        },
        crypto: {
            enabled: false,
        },
        dpasa: {
            enabled: false,
        },
        soikie: {
            enabled: false,
            url: 'https://soikie.com/',
        },
    },
    oidc: {
        github: true,
        google: true,
        ethereum: true,
    },
    sentry: {
        enabled: true,
        dsn: 'https://a7607287ba53453897b34276cb967443@o952724.ingest.sentry.io/6753216',
        tunnel: '/tunnel',
        environment: 'Dev-Staging',
    },
};
export default CONFIGURATION;
